import ajax from "../assets/uilt/ajax";
export default {
  /**查询机构的卡账户信息 */
  countToday: (req) => {
    return ajax.get({
      url: "/home/count-today",
      param: req.param,
      success: req.success,
    });
  },
  /**分页查询网点 */
  pageBranch: (req) => {
    return ajax.get({
      url: "/home/page-branch",
      param: req.param,
      success: req.success,
    });
  },
};
